import React, { Component } from "react";
import { 
  Button, 
  CircularProgress, 
  Dialog, 
  DialogContent, 
  DialogTitle, 
  IconButton, 
  MenuItem, 
  Paper, 
  Select, 
  TextField,
  withStyles, 
} from "@material-ui/core";
import clsx from "clsx";
import { Translation } from "react-i18next";
import HelpOutlineIcon from "@material-ui/icons/HelpOutline";
import CloseIcon from "@material-ui/icons/Close";
import SearchIcon from "@material-ui/icons/Search";
import { helpType, helpTypes } from "./Const";
import HelpContent from "./HelpContent";
// import withStyles from "@material-ui/core/styles/withStyles";
 import { styles } from "./Help.css";
import { MdMessage } from "react-icons/md";

import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { flushSync } from "react-dom";

const getCategoryLabel = (category)=>{
  return helpTypes.find(v=> v.id === category).label
}

class HelpMain extends Component {
  helpSearchReff;

  constructor(props) {
    super();
    this.state = {
      openPopup : false,
      selectedHelp : props.selectedHelp || {},
      filter: helpType.ALL,
      searchQuery: "",
      collapsedList: null
    };

    //binding "this" to closeHelpPopup to be able to close the dialog on background click
    this.closeHelpPopup = this.closeHelpPopup.bind(this);
    this.handleOnSubmitSearchForm = this.handleOnSubmitSearchForm.bind(this);
  }

  componentDidMount(){
    const{help: { helpItems }, config} = this.props;
    if(config.module){
      this.setState({
        filter: config.module
      });
    }
  }

  componentDidUpdate(prevProps){
    const{config, getHelpData} = this.props;

    if(prevProps?.config?.id !== config?.id){
      this.setState({
        filter: config.module,
        searchQuery: "",
      },()=>{
        if(this.state.filter !== helpType.ALL){
          getHelpData(config, this.state.filter, this.state.searchQuery);
        }else{
          getHelpData(config, helpType.ALL, this.state.searchQuery);
          }
      });
    }
  }

  componentWillUnmount(){ }

  handleClose = () => {
    const { onClose} = this.props;

    this.setState({
      filter: helpType.ALL,
      searchQuery: "",
    },()=>{     
      onClose();
    })

  };

  handleFilterChange = (e) =>{

    const {
      config,
      getHelpData
    } = this.props;

    this.setState({
      filter : e.target.value
    },()=>{     
      if(this.state.filter !== helpType.ALL){
        getHelpData(config, this.state.filter, this.state.searchQuery);
      }else{
        getHelpData(config, helpType.ALL, this.state.searchQuery);
        }
    })
  }

  handleOnChangeHelpKeyword = (e) => {
    this.setState({
      searchQuery : e.target.value
    },()=>{
      this.helpSearchReff.focus();
    })
  };

  handleOnSubmitSearchForm(e){
    e.stopPropagation();
    e.preventDefault();

    const {
      config,
      getHelpData
    } = this.props;

    if(this.state.filter !== helpType.ALL){
      getHelpData(config, this.state.filter, this.state.searchQuery);
    }else{
      // getHelpData(config, '', this.state.searchQuery);
      getHelpData(config, helpType.ALL, this.state.searchQuery);
        if(this.state.collapsedList){
          let colList = {}
          Object.keys(this.state.collapsedList).map(v =>{
            colList[v] = false;
          })

          this.setState(prevState => ({
            collapsedList: {
              ...prevState.collapsedList,
              ...colList
            },
          }) );

        }
      }


  }

  openHelpPopup(event, helpItem){
    event.preventDefault();
    event.stopPropagation();

    this.setState({
      selectedHelp : helpItem,
    },()=>{      
     this.setState({ openPopup : true})
    })
  }

  closeHelpPopup(){
    this.setState({
      openPopup : false
    })
  }



  multiKeySort(a, b){
    // let aa = `${getCategoryLabel(a.category)}`;
    // let bb = `${getCategoryLabel(b.category)}`;
    let aa = a.order;
    let bb = b.order;

    if ( aa < bb ){
      return -1;
    }
    if ( aa > bb ){
      return 1;
    }
    return 0;
  }

  handleCollapsedChange = (panel)=>{
      this.setState(prevState => ({
        collapsedList: {
          ...prevState.collapsedList,
          [panel] : Boolean(this.state?.collapsedList && this.state?.collapsedList[panel]) ? !this.state.collapsedList[panel] : true
        },
      }));

  }

  renderHelpList=(items)=>{
    const { classes } = this.props;

    let helpItems = items || [];

    // helpItems.sort(this.multiKeySort)

    switch (this.state.filter) {
      case helpType.ALL:
        // let groupBy = function(xs, key) {
        //   return xs.reduce(function(rv, x) {
        //     (rv[x[key]] = rv[x[key]] || []).push(x);
        //     return rv;
        //   }, {});
        // };

        // let groupedItems = groupBy([...helpItems], 'category')
        
        // return(
        //   Object.keys(groupedItems).map((hItem ,index) =>{
        //     return(
        //       <>
        //         <Accordion 
        //           defaultExpanded={true}
        //           expanded={this.state?.collapsedList ? !this.state?.collapsedList[hItem] : true}
        //           onChange={()=>{this.handleCollapsedChange(hItem)}}
        //         >
        //           <AccordionSummary
        //             expandIcon={<ExpandMoreIcon />}
        //             aria-controls="panel1a-content"
        //             id="panel1a-header"
        //           >
        //             <Typography >{getCategoryLabel(hItem) || ''}</Typography>
        //           </AccordionSummary>
        //           <AccordionDetails className={classes.helpDetails}>
        //             {
        //               groupedItems[hItem].map((helpItem,i)=>{
        //                 return(
        //                   <>
        //                     <MenuItem
        //                         key={`${helpItem.id}-${index}-${i}`}
        //                         tabIndex={0}
        //                         onKeyDown={(event) =>
        //                           event.key == 'Enter' ? this.openHelpPopup(event, helpItem) : null
        //                         }
        //                         onClick={(event) => this.openHelpPopup(event, helpItem) }
        //                         aria-label={"help item"}
        //                         className={classes.helpSingleItems}
        //                       >
                              
        //                           <MdMessage /> {helpItem?.title}
                            
        //                     </MenuItem>
        //                   </>
        //                 )
        //               })
        //             }
        //           </AccordionDetails>
        //         </Accordion>             
        //       </>
        //     )
        //   }
        // )
        // );

        return(
          helpItems.map((helpItem,i) =>{
            return (
            <>
              <MenuItem
                  key={`${helpItem.id}-${i}`}
                  tabIndex={0}
                  onKeyDown={(event) =>
                    event.key == 'Enter' ? this.openHelpPopup(event, helpItem) : null
                  }
                  onClick={(event) => this.openHelpPopup(event, helpItem) }
                  aria-label={"help item"}
                  className={classes.helpSingleItems}
                >
                
                <MdMessage /> <div title={helpItem?.title || ''}>{helpItem?.title}
                <span className={classes.categoryType} title={getCategoryLabel(helpItem.category) || ''}> {getCategoryLabel(helpItem.category) || ''}</span>
                </div>
                    
               
              </MenuItem>
            </>
          )})
        );

      default:
        return(
          helpItems.map((helpItem,i) =>{
            return (
            <>
              <MenuItem
                  key={`${helpItem.id}-${i}`}
                  tabIndex={0}
                  onKeyDown={(event) =>
                    event.key == 'Enter' ? this.openHelpPopup(event, helpItem) : null
                  }
                  onClick={(event) => this.openHelpPopup(event, helpItem) }
                  aria-label={"help item"}
                  className={classes.helpSingleItems}
                >
                
                    <MdMessage /> {helpItem?.title}
              
              </MenuItem>
            </>
          )})
        );
    }

  }



  render() {
    const { 
        classes,
        help: { loadingContent, helpItems },
        config
     } = this.props;

     const { selectedHelp, searchQuery } = this.state;

    return (
      <Translation key={Math.random()}>
        {(t, { i18n }) => (
          <>
            <div className={classes.helpGlobalWrapperRight}>
              <div className={clsx(classes.panelHeader, classes.helpPanelHeader)}>             
                  <h2 className={classes.textAlignLeft}><HelpOutlineIcon /> {config.id === helpType.ALL ? 'General Help' : 'Help'}</h2>     
                <Button
                  aria-label="Close"
                  title="Close"
                  className={clsx(
                    classes.helpCommonTopButton,
                    classes.helpbuttonCustomSize,
                    classes.globalGrayButton
                  )}
                  onClick={this.handleClose}
                >
                  <CloseIcon />
                </Button>
              </div>
            
              <div className={classes.helpSearchArea}>
                  <form
                      noValidate
                      className={classes.searchForm}
                      onSubmit={this.handleOnSubmitSearchForm}
                  >
                      <label className={classes.appbarHideLabel} aria-hidden="true" htmlFor={`helpSearch-${config.id}`}>{"help"}</label>
                      <TextField
                          id={`helpSearch-${config.id}`}
                          name={`helpSearch-${config.id}`}
                          type="text"
                          autoComplete="off"
                          aria-label={"search help"}
                          className={classes.searchTextField}
                          value={searchQuery || ""}
                          onChange={this.handleOnChangeHelpKeyword}
                          disabled={loadingContent[config.id] || false}
                          inputRef={(input) => { this.helpSearchReff = input; }} 
                      ></TextField>
                      <Button
                          type="submit"
                          variant="contained"
                          color="primary"
                          aria-label={"search help"}
                          className={clsx(classes.globalGreenButton,classes.helpSearchButton)}
                          disabled={loadingContent[config.id] || false}
                      >
                      {loadingContent[config.id] ? (
                          <CircularProgress className={classes.circularProgressIcon} />
                      ) : (
                          <SearchIcon className={classes.searchIcon} />
                      )}
                      </Button>
                      {(config.module && config.module === helpType.ALL) && 
                        <Select
                            labelId="resSize"
                            id="resSize"
                            name="helpModule"
                            label="helpModule"
                            inputProps={{
                              id: "resSize",
                              "aria-labelledby": "resSize",
                            }}
                            disableUnderline
                            value={this.state.filter || helpType.ALL}
                            onChange={this.handleFilterChange}
                            className={clsx(
                              classes.appbarSelect,
                              classes.advancedSearchMainDropdown
                            )}
                          >
                            {helpTypes.map((v) => {
                              return( 
                                <MenuItem
                                  key={v.id}
                                  className={classes.selectOptions}
                                  value={v.id}
                                >
                                  {v.label}
                                </MenuItem>
                              )})}
                          </Select>
                        }
                  </form>
           
              </div>
              {config.id === helpType.ALL && 
              <div>
                <span class="helpViewPanel">Help / {getCategoryLabel(this.state.filter)}</span>
              </div>
              }
                <Paper className={clsx(classes.paperwrap, classes.paperWidth, classes.helpPaperwrap,)}>
              
                    <div className={clsx(classes.muListWrap, classes.helpmuListWrap)}> 
                      { !loadingContent[config.id] && helpItems[config.id]?.length > 0 && this.renderHelpList(helpItems[config.id]) }
                      {/* { !loadingContent[config.id] && helpItems[config.id]?.length > 0 && this.renderHelpList(helpItems[config.id]).map((helpItem,i) =>{
                        return (
                        <>
                          <MenuItem
                              key={helpItem.id + i}
                              tabIndex={0}
                              onKeyDown={(event) =>
                                event.key == 'Enter' ? this.openHelpPopup(event, helpItem) : null
                              }
                              onClick={(event) => this.openHelpPopup(event, helpItem) }
                              aria-label={"help item"}
                              className={classes.helpSingleItems}
                            >
                            
                                <MdMessage /> {helpItem?.title}
                          
                          </MenuItem>
                        </>
                      )}) }  */}
                      { !loadingContent[config.id] && helpItems[config.id]?.length === 0 &&
                        <span className={classes.helpNoResults}>
                        No results.
                        </span>
                      }
                    </div>
                </Paper>
                  
            </div>
         
            {selectedHelp && 
              <Dialog  onClose={this.closeHelpPopup} aria-labelledby="customized-dialog-title" open={this.state.openPopup}>
                <div className={classes.dialogMinWidth}>
                  <DialogTitle id="customized-dialog-title"  onClose={this.closeHelpPopup}>                
                  <span class="helpTitle"> {this.state.selectedHelp?.title}</span>
                    <IconButton aria-label="close" className={classes.closeButton} onClick={this.closeHelpPopup}>
                      <CloseIcon />
                    </IconButton>
                  </DialogTitle>
                  <DialogContent dividers>

                    <HelpContent 
                      selectedHelp = {selectedHelp} 
                      {...this.props} 
                    />
                    
                  </DialogContent>
                </div>
              </Dialog>
            }
          </>
        )}
      </Translation>
    );
  }
}

 export default (withStyles(styles)(HelpMain));
//export default HelpMain;
